import { useMemo } from 'react';
import { StanButton } from '@/components';
import { usePageDataStore } from '@/features/product-editor/pageStore';
import { BUTTON_LAYOUTS, type ButtonLayout } from '@/types/pageSchema';

export default function StoreCardStyle() {
    const { pageData, updatePageData } = usePageDataStore();

    const layoutButtonsData = useMemo(() => {
        return pageData.storePresentation.layout;
    }, [pageData]);

    const handleButtonChange = (layout: ButtonLayout) => {
        updatePageData({ storePresentation: { layout } });
    };

    return (
        <div className='flex flex-row pb-2'>
            <StanButton
                name='layout-button'
                variant={layoutButtonsData === BUTTON_LAYOUTS.BUTTON ? undefined : 'outline'}
                onClick={() => handleButtonChange(BUTTON_LAYOUTS.BUTTON)}
            >
                Button
            </StanButton>
            <StanButton
                name='layout-button'
                variant={layoutButtonsData === BUTTON_LAYOUTS.CALLOUT ? undefined : 'outline'}
                onClick={() => handleButtonChange(BUTTON_LAYOUTS.CALLOUT)}
            >
                Callout
            </StanButton>
            <StanButton
                name='layout-button'
                variant={layoutButtonsData === BUTTON_LAYOUTS.PREVIEW ? undefined : 'outline'}
                onClick={() => handleButtonChange(BUTTON_LAYOUTS.PREVIEW)}
            >
                Preview
            </StanButton>
        </div>
    );
}
